<template lang="pug">
ul.parts-nav-footer-alias(:class="classes")
  li.parts-nav-footer-alias__item(
      v-for="({ target, url, icon, text, subSign }, index) in list"
      :key="index"
    )
    ext-link.parts-nav-footer-alias__link(
      :target="target"
      :to="url"
    )
      img.parts-nav-footer-alias__img(
        :src="icon"
        :alt="text"
      )
      span.parts-nav-footer-alias__text(
        v-if="subSign"
        v-html="subSign"
      )
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';

export default {
  components: {
    ExtLink,
  },

  props: {
    list: {
      type: Array,
    },

    addType: {
      type: String,
    },
  },

  computed: {
    classes() {
      return {
        [`${this.addType}`]: this.addType,
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../stylus/helpers/mediaqueriesStep'

.parts-nav-footer-alias
  padding 0
  list-style-type none
  display flex
  flex-wrap wrap
  justify-content center

  +phone-horizontal()
    padding 0
    justify-content space-around

  +tablet()
    padding 0 100px
    justify-content space-between

  +tablet-768()
    padding 0 200px

  +tablet-desktop()
    padding 0 28px

  &__item
    margin-bottom 38px
    flex-basis 100%

    &:last-child
      margin-bottom 0

    +phone-horizontal()
      margin-bottom 0
      flex-basis auto

    +tablet()
      margin-bottom 0
      flex-basis auto

  &__link
    color #485b84
    text-decoration none
    position relative

    &:hover
      color #51acff
      text-decoration underline

      & .parts-nav-footer-alias__text
        visibility visible
        opacity 1

      & .parts-nav-footer-alias__img
        opacity 1

  &__img
    display block
    max-height 60px
    opacity .3
    transition opacity .2s ease

  &__text
    width 180px
    margin-left -90px
    padding 6px 8px
    font-size 12px
    line-height 1.4
    text-align center
    color #FFF
    background-color #7875d0
    border-radius 4px
    box-shadow 0 2px 12px 0 rgba(#333255, .6)
    display none
    position absolute
    top 70px
    left 50%
    visibility hidden
    opacity 0
    transition opacity .2s ease
    transition-delay .1s

    &::before
      content ''
      width 0
      height 0
      border 12px solid transparent
      border-bottom solid 14px #7875d0
      display block
      position absolute
      top -24px
      left 0
      right 0
      margin 0 auto

    +desktop()
      display block
</style>



// WEBPACK FOOTER //
// FooterAlias.vue?744185f8